import { render, staticRenderFns } from "./BaseEditorQuill.vue?vue&type=template&id=4d6036c0&"
import script from "./BaseEditorQuill.vue?vue&type=script&lang=js&"
export * from "./BaseEditorQuill.vue?vue&type=script&lang=js&"
import style0 from "./BaseEditorQuill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports